export class RTWResponseStatus {
  msg:string;
  isSuccess : boolean;
  isBlocked?: boolean;
  requestValid: boolean;
  jurisReqStatus: boolean;
  tamsReqStatus: boolean;
  errorCode?: string;
  submissionDate?: string;
  submissionTime?: string;
  nextEligibleDate?: string;
}

export const RTW_SAME_DAY_ERROR_CODE = 'SameDaySubmission';

export class RtwStatus {
  Userid:string;
  Cont_num: string;
  Empunum: string;
  ServiceMethod: string;
  TargetSystem: string;
  WorkType: string;
  RtwDate: string;
  RequestValid: boolean;
  JurisReqStatus: boolean;
  TamsReqStatus: boolean;
 }
